import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Duration } from 'luxon'
import Metric from './metric'

import useStyles from './statusDurationStyle'

const StatusDuration = (props) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const [statusDuration, setStatusDuration] = useState()
  const [statusTime, setStatusTime] = useState(['', ''])
  const statusRef = useRef()

  const translateName = (name) => {
    if (name === 'Online') return 'Atendendo'
    if (name === 'Volto logo') return 'Pré-pausa'
    return name
  }

  const handleStatusTime = () => {
    const start = new Date(props?.goals?.status?.start_time).getTime()
    const secs = parseInt((Date.now() - start) / 1000)
    const format = props?.large ? 'hh:mm:ss' : 'hh:mm'

    const val = Number.isInteger(secs)
      ? Duration.fromObject({
          seconds: secs,
        }).toFormat(format)
      : '-'

    setStatusDuration(val)
  }

  const getStatusTitle = (status) => {
    const title = (
      <div className={classes.statusDuration}>
        <div>{t('commons.statusDuration')}</div>
        <div>{`${t('commons.current')}: ${status ?? '-'}`}</div>
      </div>
    )
    return title
  }

  useEffect(() => {
    if (!props?.goals) return
    if (statusRef?.current) clearInterval(statusRef.current)

    // Execute first
    handleStatusTime()

    // Set routine
    statusRef.current = setInterval(() => handleStatusTime(), 1000)

    setStatusTime([
      translateName(props?.goals?.status?.availability_name),
      props?.goals?.status?.start_time,
    ])
  }, [props?.goals, props?.large])

  return (
    <Metric
      title={getStatusTitle(statusTime[0])}
      large={props?.large}
      value={statusDuration}
    />
  )
}

export default StatusDuration
